<script setup lang="ts">
const props = defineProps<{ prefix: "billing" | "shipping" }>();
const { cart } = useCart();
const { result, onSubmit, onReset: onResetForm, isSubmitting } = useUpdateCustomerDetailsForm(props.prefix);
const showForm = ref(false);
function onReset() {
  showForm.value = false;
  onResetForm();
}
</script>

<template>
  <div>
    <UiFormWrapper v-show="showForm" :result="result" @submit="onSubmit" @reset="onReset">
      <FieldCustomerDetails name="customer_details" :prefix="prefix" required />
      <div class="flex items-center gap-4">
        <UiSubmitButton :is-submitting="isSubmitting">
          Enregistrer
        </UiSubmitButton>
        <button type="button" class="link-prose" @click="showForm = false">
          Annuler
        </button>
      </div>
      <template #success>
        <div class="message prose">
          <p class="text-success">
            {{ prefix === "billing" ? "Adresse de facturation" : "Adresse de livraison" }} mise à jour avec succès.
          </p>
          <button type="button" class="link-prose" @click="onReset">
            Ok
          </button>
        </div>
      </template>
    </UiFormWrapper>
    <div v-if="!showForm" class="space-y-4">
      <CustomerDetails :customer-details="cart.customer[prefix]" />
      <button type="button" class="link-prose" @click="showForm = true">
        Modifier
      </button>
    </div>
  </div>
</template>
